import React from "react";

export default function EmptyScreen({message, cols}){
    return(
        <tr>
            <td colSpan={cols} className="sm:text-center text-start sm:pl-0 
                xs:pl-[200px] pl-[100px]">
                <div className="h-[180px] mt-[100px]">
                    <p className="text-[18px] font-medium  leading-normal 
                        text-[#34343 mb-4">
                        {message}
                    </p>
                </div>
            </td>
        </tr>
    )
}